<template>
  <div>
    <el-card class="box-card">
      <el-form ref="queryParams" :model="queryParams" :inline="true">
        <el-form-item label="开始日期" prop="startDate">
          <el-date-picker
            v-model="queryParams.startDate"
            type="date"
            placeholder="选择日期"
            value-format="yyyy-MM-dd"
            @keyup.enter.native="handleQuery"
          />
        </el-form-item>
        <el-form-item label="结束日期" prop="endDate">
          <el-date-picker
            v-model="queryParams.endDate"
            type="date"
            placeholder="选择日期"
            value-format="yyyy-MM-dd"
            @keyup.enter.native="handleQuery"
          />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" size="mini" @click="handleQuery">查询</el-button>
          <!--            <el-button icon="el-icon-refresh" size="mini" @click="resetQuery">重置</el-button>-->
        </el-form-item>
      </el-form>

      <div ref="chartContainer" style="width: 100%; height: 400px;" />
    </el-card>
  </div>
</template>

<script>
import echarts from 'echarts'
import { getNewUserSpinStat } from '@/api/statistics/user_remain'
import { dateStrTodate } from '@/utils'

export default {
  name: 'NewUserSpinStat',
  data() {
    return {
      country: [],
      queryParams: {
        pageIndex: 1,
        pageSize: 10,
        startDate: '',
        endDate: '',
        type: 1
      }
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.initChart()
    })
  },
  methods: {
    handleQuery() {
      if (this.queryParams.startDate === '') {
        this.msgError('请选择开始日期')
        return
      }

      if (this.queryParams.endDate === '') {
        this.msgError('请选择结束日期')
        return
      }
      if (this.queryParams.startDate > this.queryParams.endDate) {
        this.msgError('开始日期不能大于结束日期')
        return
      }

      this.initChart()
    },
    initChart() {
      const chart = echarts.init(this.$refs.chartContainer)
      const option = {
        title: {
          text: '新增玩家体力分布'
        },
        legend: {
          data: [],
          x: 'center',
          y: 'bottom'
        },
        xAxis: {
          name: '日期',
          type: 'category',
          data: [],
          axisLabel: {
            interval: 0 // 设置为0，表示所有的标签都显示
          }
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '10%',
          containLabel: true
        },
        yAxis: {
          type: 'value',
          axisLabel: {
            formatter: '{value}' // 使用默认的数值格式
          }
        },
        toolbox: {
          show: true,
          feature: {}
        },
        tooltip: {
          trigger: 'axis'
        },
        series: []
      }
      chart.setOption(option)
      const dateArr = []
      const chartData = {}
      const titleMap = {
        'spin1': '0-10',
        'spin2': '11-50',
        'spin3': '51-100',
        'spin4': '101-200',
        'spin5': '201-500',
        'spin6': '501-1000',
        'spin7': '1001-2000',
        'spin8': '2001-5000',
        'spin9': '5001-10000',
        'spin10': '10000+'
      }
      getNewUserSpinStat(this.queryParams).then(res => {
        this.queryParams.startDate = res.data.req.startDate
        this.queryParams.endDate = res.data.req.endDate
        res.data.data.forEach(item => {
          dateArr.push(dateStrTodate(item.date))
          for (const k in item) {
            if (k === 'date') {
              continue
            }
            if (chartData[k] === undefined) {
              chartData[k] = []
            }

            chartData[k].push(item[k])
          }
        })

        for (const i in chartData) {
          const title = titleMap[i]
          const val = chartData[i]
          const series = {
            name: title,
            data: val,
            type: 'line',
            smooth: true,
            label: {
              show: true,
              position: 'top', // 标签显示在折线图顶部
              formatter: '{c}' // 显示数值
            }
          }
          option.legend.data.push(title)
          option.series.push(series)
        }

        option.xAxis.data = dateArr
        chart.setOption(option, true)
      })
    }
  }
}
</script>

<style scoped>

</style>
